import React from "react";
import {
  StackedCarousel,
  ResponsiveContainer,
  StackedCarouselSlideProps,
} from "react-stacked-center-carousel";
import {
  slideImg1,
  slideImg2,
  slideImg3,
  slideImg4,
  slideImg5,
  slideImg6,
  slideImg7,
  slideImg8,
} from "../assets";

const data = [
  {
    image: slideImg1,
    title: "Light painting photostation",
    year: 2017,
  },
  {
    image: slideImg2,
    title: "Live lightbending",
    year: 2022,
  },
  {
    image: slideImg3,
    title: "Light paint workshops",
    year: 2017,
  },
  {
    image: slideImg4,
    title: "Slow shutter photostation",
    year: 2020,
  },
  {
    image: slideImg5,
    title: "Light motion animations",
    year: 2017,
  },
  {
    image: slideImg6,
    title: "Live stage show",
    year: 2017,
  },
  {
    image: slideImg7,
    title: "Corporate photobooth",
    year: 2017,
  },
  {
    image: slideImg8,
    title: "Content design",
    year: 2017,
  },
];

export function ResponsiveCarousel() {
  const ref = React.useRef();
  return (
    <div style={{ width: "100%", position: "relative" }}>
      <div className="bg-black flex min-h-full flex-1 flex-col items-center text-center justify-center  py-24 lg:px-8 overflow-hidden">
        <h1
          data-aos="fade-up"
          className="font-extrabold font-gunterz text-[27px] md:text-[31px] text-white lg:text-[55px]"
        >
          YEARS OF INNOVATION
        </h1>
        <h1
          data-aos="fade-up"
          className="font-light custom-gradient-2 text-[22px] font-gotham md:text-[26px] mb-5 lg:text-[45px]"
        >
          LIGHT YEARS AHEAD
        </h1>
      </div>
      <ResponsiveContainer
        carouselRef={ref}
        render={(parentWidth, carouselRef) => {
          let currentVisibleSlide = 7;
          let fade = 0.03;
          let width = 300;
          if (parentWidth <= 1440 && parentWidth >= 1080) {
            currentVisibleSlide = 5;
            fade = 0.1;
          } else if (parentWidth <= 1080 && parentWidth >= 720)
            currentVisibleSlide = 3;
          else if (parentWidth <= 720) {
            currentVisibleSlide = 3;
            width = 200;
          }
          return (
            <StackedCarousel
              ref={carouselRef}
              data={data}
              carouselWidth={parentWidth}
              slideWidth={width}
              fadeDistance={fade}
              slideComponent={Card}
              maxVisibleSlide={7}
              currentVisibleSlide={currentVisibleSlide}
              useGrabCursor={true}
            />
          );
        }}
      />
    </div>
  );
}

// Very important to memoize your component!!!
const Card = React.memo(
  function(props: StackedCarouselSlideProps) {
    const { data, dataIndex } = props;
    const { image, title, year } = data[dataIndex];
    return (
      <div style={{ width: "100%", height: 420 }}>
        <img
          draggable={false}
          style={{
            objectFit: "cover",
            borderRadius: 20,
          }}
          src={image}
          alt=""
        />
        <div className="absolute top-48 md:top-72 ml-2">
          <p className="text-sm font-gotham bg-white text-black rounded-md w-11 md:w-24 mb-2 font-bold px-2 lg:text-2xl">
            {year}
          </p>
          <h1 className="text-white font-gotham lg:text-3xl font-extrabold">
            {title}
          </h1>
        </div>
      </div>
    );
  },
  function(prev: StackedCarouselSlideProps, next: StackedCarouselSlideProps) {
    return prev.dataIndex === next.dataIndex;
  },
);
